<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="justify-end align-end text-end">
        <v-btn color="success" @click="showModal">
          <v-icon class="white--text">mdi-plus</v-icon>
          Top Up Account
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog v-model="dialog" width="600">
        <sms-campaign-form/>
      </v-dialog>
    </v-row>
    <v-row>
      <v-col cols="12">
        <table-widget title="Top Ups" :headers="headers" :table-row-data="sms"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TableWidget from "@/components/widgets/tables/TableWidget";
import SmsCampaignForm from "@/components/widgets/forms/smsCampaignForm";
import {getRequest} from "@/api/apirepository";

export default {
  name: "TopUps",
  metaInfo: {
    title: 'Top Ups',
  },
  components: {SmsCampaignForm, TableWidget},
  data() {
    return {
      headers: [
        {
          text: 'Electoral Region',
          align: 'left',
          sortable: true,
          value: 'orderRef',
        },
        {text: 'Constituents', value: 'vehicle'},
        {text: 'Calls', value: 'fueltype'},
        {text: 'Received', value: 'fueltype'},
        {text: 'Not Reachable', value: 'fueltype'},
        {text: 'Hang up', value: 'fueltype'},
        {text: 'Cost', value: 'volume'},
        {text: 'Actions', value: 'action'}
      ],
      sms: [],
      dialog: false,
    }
  },
  methods: {
    showModal() {
      this.dialog = true;
    },
    getSMSCampaigns() {
      getRequest('smsCampaign').then(({data})=>{
        this.sms = data;
      }).catch(e=>{
        console.log(e)
      })
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>